import { render, staticRenderFns } from "./detailTabs.vue?vue&type=template&id=a7ea019a&scoped=true&functional=true&"
import script from "./detailTabs.vue?vue&type=script&lang=js&"
export * from "./detailTabs.vue?vue&type=script&lang=js&"
import style0 from "./detailTabs.vue?vue&type=style&index=0&id=a7ea019a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "a7ea019a",
  null
  
)

export default component.exports